import classNames from 'classnames';
import React from 'react';
import StickyNote2 from '@mui/icons-material/StickyNote2';
import ComponentProps from 'store/types/ComponentProps';
import { MainEventRegistrationView } from 'store/types/events/EventRegistration';

import rowStyles from '../EventInfoRow.module.scss';

interface EventCalendarIconProps extends ComponentProps {
  data: MainEventRegistrationView;
}

const EventMemoRow: React.FunctionComponent<EventCalendarIconProps> = ({ data: { memo }, className = '' }) => (
  <div className={classNames(rowStyles.row, className)}>
    <StickyNote2 className={rowStyles.icon} />
    {memo}
  </div>
);

export default EventMemoRow;
